module.exports = __webpack_public_path__ + "static/Roboto-LightItalic-d1efcd4d126837fe0dcf9b6cf3a00d64.ttf";